
import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { BlogLayout, Aside } from "../components";
import ajaxService from "../services/ajax-service";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Blog = () => {
  const { i18n } = useTranslation();
  const { slug } = useParams();
  const location = useLocation();

  const [blog, setBlog] = useState();
  const [recent, setRecent] = useState([]);

  const loadData = async () => {
    try {
      const currentLang = i18n.language || "en";

      const response = await ajaxService.get(
        `/blog/details/${slug}?lang=${currentLang}`
      );

      const { success, data, recentBlogs } = response;

      if (success) {
        setRecent(recentBlogs?.data || []);
        setBlog(data);
      }
    } catch (error) {
      console.error("Failed to load blog:", error);
    }
  };

  useEffect(() => {
    loadData();
  }, [location.pathname, i18n.language]);

  return (
    <Box
      component="main"
      className="w-full h-auto m-0 py-10 px-4 sm:py-16 sm:px-8 lg:px-16 bg-white"
    >
      <Grid container spacing={{ xs: 4, md: 5 }}>
        {/* Main Blog Content */}
        <Grid item xs={12} sm={8} minWidth={0}>
          <BlogLayout blog={blog} />
        </Grid>

        {/* Sidebar */}
        <Grid
          item
          xs={12}
          sm={4}
          component="aside"
          className="min-w-0"
        >
          <Aside latest={recent} />

          {/* Buraq Star SEO & Product Promotion */}
          <section
            className="relative overflow-hidden border border-[#F5AC55] bg-white shadow-sm mt-8"
            aria-labelledby="buraq-star-products-heading"
          >
            {/* Brand accent */}
            <div className="h-1.5 w-full bg-[#F5AC55]" />

            <div className="p-5 sm:p-6">
              <p className="text-md font-bold uppercase tracking-widest text-gray-500 mb-3">
                Buraq Star Trading Co. LLC
              </p>

              <h2
                id="buraq-star-products-heading"
                className="text-xl font-bold leading-snug text-gray-900 mb-4"
              >
                Electrical Products in the UAE for Every Project
              </h2>

              <p className="text-sm leading-6 text-gray-600 mb-4">
                Discover reliable electrical products and solutions for
                residential, commercial, and industrial applications.
                Explore our range of electrical accessories, lighting
                products, switches, sockets, and ventilation fans.
              </p>

              <p className="text-sm leading-6 text-gray-600 mb-5">
                Shop products from our brands, including{" "}
                <strong className="text-gray-500">NOVEX</strong> ,{" "}
                <strong className="text-gray-500">CAVIL</strong> ,{" "}
                <strong className="text-gray-500">BURAQ</strong> , and{" "}
                <strong className="text-gray-500">ZILCO</strong>.
                Find lighting solutions, MCBs, RCCBs, and other
                electrical supplies for your next project.
              </p>

              {/* Product categories */}
              <div className="flex flex-wrap gap-2 mb-6">
                {[
                  "Lighting",
                  "Switches & Sockets",
                  "Circuit Protection",
                  "Ventilation Fans",
                ].map((category) => (
                  <span
                    key={category}
                    className="rounded-md border border-gray-200 bg-gray-50 px-3 py-1.5 text-xs font-medium text-gray-700"
                  >
                    {category}
                  </span>
                ))}
              </div>

              {/* Internal links */}
              <div className="space-y-3 mb-6">
                <a
                  href="https://buraqstar.com/category"
                  aria-label="Browse electrical products in the UAE"
                  className="flex items-center justify-between gap-3 text-md font-semibold text-[#F5AC55] hover:text-blue-900 transition-colors"
                >
                  <span>Browse All Products</span>
                  <span aria-hidden="true">→</span>
                </a>

                <a
                  href="https://buraqstar.com/brand/novex"
                  aria-label="Explore Buraq Star product brands"
                  className="flex items-center justify-between gap-3 text-md font-semibold text-[#F5AC55] hover:text-blue-900 transition-colors"
                >
                  <span>Explore Our Brands</span>
                  <span aria-hidden="true">→</span>
                </a>
              </div>

              {/* Main CTA */}
              <a
                href="https://buraqstar.com/products"
                aria-label="Shop electrical products at Buraq Star"
                className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#F5AC55] px-4 py-3 text-md font-semibold text-white transition-colors duration-200 hover:bg-[#E59A45] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F5AC55] focus-visible:ring-offset-2"
              >
                Shop Electrical Products
                <span aria-hidden="true">→</span>
              </a>

              <p className="text-center text-xs leading-5 text-gray-500 mt-4">
                Your electrical products partner in the UAE since 2002.
              </p>
            </div>
          </section>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Blog;